import { configureStore } from "@reduxjs/toolkit";
import SiteSlice from "./SiteSlice";

const Store = configureStore({
    reducer:SiteSlice.reducer,
});
export default Store;